import axios from 'axios';


const fatch = async(params)=>{
    let qParams = new URLSearchParams(params).toString();
    let url = "/products/productList"
    url = `${url}?${qParams}`
    const response = await axios({
        url: url,
        method: "GET",
        headers: {
            "Accept-Language": "en-US,en;q=0.8"
        }
    })
    return response
}

const create = async(formData)=>{
    console.log(formData)
    let url = formData.id?"/products/editProduct":"/products/addProduct"
    const response = await axios({
        url: url,
        method:"POST",
        data: formData,
        headers: {
            "Accept-Language": "en-US,en;q=0.8"
        }
    })
    return response
}

const getProductById = async(productId)=>{
    let url = `products/${productId}`
    url = `${url}`
    const response = await axios({
        url: url,
        method: "GET",
        headers: {
            "Accept-Language": "en-US,en;q=0.8"
        }
    })
    return response
}

const exports = {
    create,
    fatch,
    getProductById
}
export default exports;